import { schema } from 'normalizr';
export var groupSchema = new schema.Entity('group', {}, {
    idAttribute: 'userId',
});
//# sourceMappingURL=group.js.map